import { store } from '@wordpress/interactivity';

import { debounce } from '../../utils';

const { state } = store('mediapress-listicle', {
  state: {
    observer: null,
  },
  callbacks: {
    lifecycleObserver: () => {
      if (state.observer) return;

      const debouncedReplaceState = debounce((id) => {
        history.replaceState(null, '', `#${id}`);
      }, 200);

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const id = entry.target.id;
              if (id) {
                debouncedReplaceState(id);
              }
            }
          });
        },
        {
          rootMargin: '-200px 0px',
          threshold: [0.5],
        },
      );

      state.observer = observer;

      /**
       * Returning a function acts like a unmount hook.
       * https://developer.wordpress.org/block-editor/reference-guides/interactivity-api/api-reference/#wp-watch:~:text=the%20callback%20changes-,The,will%20run%20again%20when%20the%20element%20is%20removed%20from%20the%20DOM.,-As%20a%20reference
       */
      return () => {
        if (state.observer) {
          state.observer.disconnect();
          state.observer = null;
        }
      };
    },
  },
});
